export default class ResetUserActivationToken {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    var user = this.context.stores.users.find(id);
    user.resetActivation();
    this.context.stores.users.replace(user);
    this.context.gateways.user.updateActivationToken(id);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/user/reset_user_activation_token.js